"use client"

import { FragmentType, graphql, useFragment } from "@/gql"
import {
  AvatarWithNameAndTitleContentFragmentDoc,
  RedactedClientAvatarWithNameAndTitleFragmentDoc,
  RedactedCreativeAvatarWithNameAndTitleFragmentDoc,
} from "@/gql/graphql"
import React from "react"
import {
  AvatarWithNameAndTitleContent,
  AvatarWithNameAndTitleSize,
  AvatarWithNameAndTitleSizeVariant,
} from "./AvatarWithNameTitleContent"

graphql(`
  fragment RedactedCreativeAvatarWithNameAndTitle on RedactedIndividualCreative {
    id
    avatar120: avatarUrl(width: 120)
    avatar240: avatarUrl(width: 240)
    description
  }
`)

interface Props {
  creative: FragmentType<typeof RedactedCreativeAvatarWithNameAndTitleFragmentDoc> | null | undefined
  size: AvatarWithNameAndTitleSize
  variant: AvatarWithNameAndTitleSizeVariant
  className?: string
  canClick?: boolean
  titleMaxLines?: number
  subtitleMaxLines?: number
}

export const RedactedCreativeAvatarWithNameAndTitle: React.FC<Props> = props => {
  const creative = useFragment(RedactedCreativeAvatarWithNameAndTitleFragmentDoc, props.creative)

  const fakeFragment = {
    __typename: "User",
    id: "#",
    name: "",
    avatarInitials: "??",
    profile: {
      __typename: "UserProfile",
      id: "#",
      avatar120: creative?.avatar120,
      avatar240: creative?.avatar240,
    },
  }

  return (
    <AvatarWithNameAndTitleContent
      user={fakeFragment as FragmentType<typeof AvatarWithNameAndTitleContentFragmentDoc> | undefined | null}
      title={creative?.description || "Creative"}
      subtitle={undefined}
      redacted={true}
      {...props}
    />
  )
}
